import { render, staticRenderFns } from "./homeBottomTu.vue?vue&type=template&id=525dfebc&scoped=true"
import script from "./homeBottomTu.vue?vue&type=script&lang=js"
export * from "./homeBottomTu.vue?vue&type=script&lang=js"
import style0 from "./homeBottomTu.vue?vue&type=style&index=0&id=525dfebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dfebc",
  null
  
)

export default component.exports